<template>
  <div v-if="isSellerPartner" class="relative inline-block">
    <!-- Bouton solde f'topbar — l-montant مخبّي حتى klika 3la l-3ين -->
    <div class="flex flex-row items-center gap-1 px-3 py-1.5 mt-1 md:mt-0 text-sm font-semibold rounded-full border border-gray-200 bg-white text-gray-800 hover:border-green-400 hover:bg-green-50 transition-colors">
      <button @click="openModal" class="flex flex-row items-center gap-1 focus:outline-none">
        <i class="material-icons text-green-600" style="font-size:20px;">account_balance_wallet</i>
        <span class="hidden sm:flex items-baseline gap-1 leading-none">
          <span>
            <template v-if="showBalance">{{ formatAmount(balance) }}</template>
            <template v-else>••••••</template>
          </span>
          <sup class="font-bold uppercase text-gray-400 text-[10px]">{{ currencyLabel }}</sup>
        </span>
      </button>
      <button @click.stop="showBalance = !showBalance" class="text-gray-400 hover:text-gray-600 focus:outline-none ml-0.5" :title="showBalance ? 'Masquer' : 'Afficher'">
        <i class="material-icons" style="font-size:16px;">{{ showBalance ? 'visibility_off' : 'visibility' }}</i>
      </button>
    </div>

    <!-- Modal -->
    <vue-modal-2 name="WalletModal" :headerOptions="{ title: label('My wallet', 'Mon portefeuille') }" :noFooter="true" modalSize="md" @on-close="onClose">
      <div class="bg-white rounded-lg">

        <!-- Header gradient solde -->
        <div class="p-5 text-white" style="background:linear-gradient(135deg,#16a34a,#15803d);">
          <div class="flex items-center justify-between">
            <span class="text-xs uppercase tracking-wide opacity-80">{{ label('Available balance', 'Solde disponible') }}</span>
            <i class="material-icons opacity-80">account_balance_wallet</i>
          </div>
          <div class="mt-1 text-4xl font-bold leading-none">
            {{ formatAmount(balance) }} <span class="text-xl font-medium">{{ currencyLabel }}</span>
          </div>
          <div class="text-sm opacity-80 mt-2">
            {{ label('Total received', 'Total reçu') }}: {{ formatAmount(totalReceived) }} {{ currencyLabel }}
          </div>
        </div>

        <!-- Body -->
        <div class="p-5">
          <!-- Hold balance (payments pending, mazal machi f'wallet) -->
          <div class="mb-4 flex items-center justify-between rounded-lg bg-amber-50 border border-amber-200 px-4 py-3">
            <div class="flex items-center gap-2">
              <i class="material-icons text-amber-500" style="font-size:20px;">hourglass_full</i>
              <div class="flex flex-col leading-tight">
                <span class="text-xs font-semibold text-amber-700 uppercase">{{ label('Hold balance', 'Solde en attente') }}</span>
                <span class="text-xs text-amber-600">{{ hold.count || 0 }} {{ label('pending payments', 'paiements en attente') }}</span>
              </div>
            </div>
            <span class="text-lg font-bold text-amber-700">{{ formatAmount(holdBalance) }} <sup>{{ currencyLabel }}</sup></span>
          </div>

          <!-- Form withdraw -->
          <label class="text-sm font-medium text-gray-600">{{ label('Withdraw amount', 'Montant à retirer') }}</label>
          <div class="mt-1 relative">
            <input type="number" v-model="withdrawAmount" :min="minWithdraw"
              class="w-full rounded-lg border border-gray-300 pl-4 pr-24 py-3 text-base focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
              placeholder="0" />
            <div class="absolute inset-y-0 right-0 flex items-center gap-2 pr-3">
              <span class="text-sm text-gray-400 font-semibold">{{ currencyLabel }}</span>
              <button type="button" @click="setMax" class="text-sm text-green-600 font-bold hover:underline focus:outline-none">MAX</button>
            </div>
          </div>
          <button @click="submitWithdraw" :disabled="submitting || !canWithdraw"
            class="mt-4 w-full rounded-lg bg-green-600 hover:bg-green-700 text-white font-semibold py-3 text-base disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors">
            <i v-if="!submitting" class="material-icons" style="font-size:20px;">send</i>
            <span v-if="!submitting">{{ label('Request withdrawal', 'Demander un retrait') }}</span>
            <span v-else>...</span>
          </button>
          <p class="text-sm text-gray-400 mt-2 text-center">
            {{ label('Minimum withdrawal', 'Retrait minimum') }}: {{ minWithdraw }} {{ currencyLabel }}
          </p>

          <!-- Historique récent (dépôts + retraits) -->
          <div class="mt-5 pt-4 border-t border-gray-100">
            <div class="flex items-center justify-between">
              <span class="text-sm font-semibold text-gray-500 uppercase">{{ label('Recent transactions', 'Transactions récentes') }}</span>
              <span v-if="histTotal" class="text-xs text-gray-400">{{ histTotal }}</span>
            </div>

            <ul class="mt-2 space-y-0.5 max-h-60 overflow-auto">
              <template v-for="(h, i) in history">
              <!-- Séparateur info: devise تبدلت (payment method changé) -->
              <li v-if="i > 0 && rowCurrency(history[i-1]) !== rowCurrency(h)" :key="'sep-'+i"
                  class="flex items-center gap-1.5 my-1 px-2 py-1 text-xs text-blue-700 bg-blue-50 border border-blue-100 rounded-md">
                <i class="material-icons" style="font-size:13px;">info</i>
                <span>{{ label('Payment method changed', 'Changement de méthode de paiement') }} ({{ rowCurrency(h) }} → {{ rowCurrency(history[i-1]) }})</span>
              </li>
              <li :key="i"
                class="flex items-center justify-between py-2 px-2 rounded-md border transition-colors"
                :class="h.operationType === 'in' ? 'bg-green-50 border-green-100 hover:bg-green-100' : 'bg-red-50 border-red-100 hover:bg-red-100'">
                <div class="flex items-center gap-2 min-w-0">
                  <div class="rounded-full flex items-center justify-center flex-shrink-0" style="width:30px;height:30px;min-width:30px;"
                       :class="h.operationType === 'in' ? 'bg-green-100' : 'bg-red-100'">
                    <i class="material-icons" style="font-size:16px;line-height:1;" :class="h.operationType === 'in' ? 'text-green-600' : 'text-red-600'">
                      {{ h.operationType === 'in' ? 'arrow_downward' : 'arrow_upward' }}
                    </i>
                  </div>
                  <div class="flex flex-col leading-tight min-w-0">
                    <span class="text-sm font-semibold text-gray-700">{{ h.operationType === 'in' ? label('Deposit', 'Dépôt') : label('Withdrawal', 'Retrait') }}</span>
                    <span v-if="txRef(h)" class="text-xs text-blue-600 font-medium truncate" :title="txRef(h)">{{ txRef(h) }}</span>
                    <span class="text-xs text-gray-400">{{ $moment(h.createdAt).format('DD/MM/YY HH:mm') }}</span>
                  </div>
                </div>
                <div class="text-right">
                  <div class="text-sm font-bold" :class="h.operationType === 'in' ? 'text-green-600' : 'text-red-600'">
                    {{ h.operationType === 'in' ? '+' : '-' }} {{ formatRow(h) }} {{ rowCurrency(h) }}
                  </div>
                  <span class="text-xs px-2 py-0.5 rounded-full font-medium" :class="statusClass(h.status)">{{ statusLabel(h.status) }}</span>
                </div>
              </li>
              </template>
              <li v-if="!loading && !history.length" class="py-4 text-sm text-gray-400 text-center">
                {{ label('No transactions yet', 'Aucune transaction') }}
              </li>
              <li v-if="loading" class="py-4 text-sm text-gray-400 text-center">...</li>
            </ul>

            <!-- Pagination -->
            <div v-if="histTotal > histPerPage" class="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
              <span class="text-xs text-gray-500">{{ label('Page', 'Page') }} {{ histPage }}/{{ histLastPage }}</span>
              <div class="flex items-center gap-2">
                <button @click="histGoTo('prev')" :disabled="histPage <= 1 || loading"
                  class="px-3 py-1 rounded border text-sm disabled:opacity-40 hover:bg-gray-100">
                  <i class="material-icons align-middle" style="font-size:16px;">chevron_left</i>
                </button>
                <button @click="histGoTo('next')" :disabled="histPage >= histLastPage || loading"
                  class="px-3 py-1 rounded border text-sm disabled:opacity-40 hover:bg-gray-100">
                  <i class="material-icons align-middle" style="font-size:16px;">chevron_right</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-modal-2>
  </div>
</template>

<script>
const MIN_WITHDRAW_USD = 20;
const MIN_WITHDRAW_MAD = 200;

export default {
  props: {
    user: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      wallet: null,
      showBalance: false,
      hold: { amount: 0, amountMAD: 0, count: 0 },
      history: [],
      histPage: 1,
      histPerPage: 5,
      histTotal: 0,
      histLastPage: 1,
      withdrawAmount: "",
    };
  },
  computed: {
    // Team members (parentSeller) ma-3ndhomش wallet (dyal l-parent) => ma-nبينوش l-widget
    isSellerPartner() {
      return this.user && ['Seller', 'Partner'].includes(this.user.type) && !this.user.parentSeller;
    },
    // Devise 3la 7sab paymentMethod: payoneer/wise => USD, sinon (bank wla walo) => MAD default
    currencyLabel() {
      const pm = this.user && this.user.paymentMethod;
      if (pm && ['payoneer', 'wise'].includes(pm.type)) return 'USD';
      return 'MAD';
    },
    balance() {
      if (!this.wallet) return 0;
      return this.currencyLabel === 'USD' ? (this.wallet.amount || 0) : (this.wallet.amountMAD || 0);
    },
    totalReceived() {
      if (!this.wallet) return 0;
      return this.currencyLabel === 'USD' ? (this.wallet.amountUSDAll || 0) : (this.wallet.amountMADAll || 0);
    },
    // Hold = payments 'pending' (facturés walakin mazal machi validés)
    holdBalance() {
      return this.currencyLabel === 'USD' ? (this.hold.amount || 0) : (this.hold.amountMAD || 0);
    },
    minWithdraw() {
      return this.currencyLabel === 'USD' ? MIN_WITHDRAW_USD : MIN_WITHDRAW_MAD;
    },
    canWithdraw() {
      const a = parseFloat(this.withdrawAmount);
      return a >= this.minWithdraw && a <= this.balance;
    },
  },
  async mounted() {
    if (this.isSellerPartner) await this.fetchWallet();
  },
  methods: {
    label(en, fr) { return this.$t ? this.$t(en) : fr; },
    formatAmount(v) {
      const n = parseFloat(v) || 0;
      return this.currencyLabel === 'USD' ? n.toFixed(2) : Math.floor(n);
    },
    // Référence: deposit li ja mn facture => comment "Bill payment (#id)" (m3mmar men validation, bla populate)
    txRef(h) {
      if (h.operationType === 'in' && h.comment) return h.comment;
      return '';
    },
    // Chaque ligne kaytبان b'devise dyalha (defaultCurrency) — machi dima nafs devise dyal l-widget
    rowCurrency(h) { return (h && h.defaultCurrency) || this.currencyLabel; },
    formatRow(h) {
      const cur = this.rowCurrency(h);
      const v = parseFloat(cur === 'USD' ? h.amount : h.amountMAD) || 0;
      return cur === 'USD' ? v.toFixed(2) : Math.floor(v);
    },
    statusClass(status) {
      if (status === 'paid') return 'bg-green-100 text-green-700';
      if (status === 'rejected') return 'bg-red-100 text-red-700';
      return 'bg-yellow-100 text-yellow-700';
    },
    statusLabel(status) {
      const map = { paid: this.label('Paid', 'Payé'), rejected: this.label('Rejected', 'Rejeté'), pending: this.label('Pending', 'En attente') };
      return map[status] || status;
    },
    setMax() {
      this.withdrawAmount = this.currencyLabel === 'USD' ? parseFloat((this.balance || 0).toFixed(2)) : Math.floor(this.balance || 0);
    },
    async openModal() {
      this.$vm2.open('WalletModal');
      this.histPage = 1;
      await this.fetchWallet();
    },
    onClose() {
      this.$vm2.close('WalletModal');
    },
    async fetchWallet() {
      this.loading = true;
      try {
        const resW = await this.$server.search("balances", { getTotalsByCurrency: true, getHold: true });
        this.wallet = resW && resW.content && resW.content.results && resW.content.results[0] ? resW.content.results[0] : null;
        this.hold = (resW && resW.content && resW.content.hold) ? resW.content.hold : { amount: 0, amountMAD: 0, count: 0 };
        await this.fetchHistory();
      } catch (e) {
        // silencieux — topbar ma-yخصهاش تتبلوكا
      } finally {
        this.loading = false;
      }
    },
    async fetchHistory() {
      // kl les transactions (dépôts 'in' + retraits 'out') dyal seller
      const resH = await this.$server.search("balancesHistories", { limit: this.histPerPage, page: this.histPage });
      if (resH && resH.content && resH.content.results) {
        this.history = resH.content.results;
        this.histTotal = resH.content.total || 0;
        this.histLastPage = resH.content.last_page || 1;
        this.histPage = resH.content.current_page || this.histPage;
      } else {
        this.history = []; this.histTotal = 0; this.histLastPage = 1;
      }
    },
    async histGoTo(dir) {
      const next = dir === 'next' ? this.histPage + 1 : this.histPage - 1;
      if (next < 1 || next > this.histLastPage) return;
      this.histPage = next;
      this.loading = true;
      try { await this.fetchHistory(); } finally { this.loading = false; }
    },
    async submitWithdraw() {
      const amount = parseFloat(this.withdrawAmount);
      if (!amount || amount <= 0) return this.$toast.warning(this.label('Amount required', 'Montant requis'));
      if (!this.$f.isNumeric(this.withdrawAmount)) return this.$toast.warning('Please enter a valid number');
      if (amount < this.minWithdraw) return this.$toast.warning(`${this.label('Minimum withdrawal', 'Retrait minimum')}: ${this.minWithdraw} ${this.currencyLabel}`);
      if (amount > this.balance) return this.$toast.warning(this.label('Amount entered is larger than your balance', 'Montant supérieur au solde'));
      if (!this.idWharhouse || !this.idWharhouse.country) return this.$toast.warning('Warehouse country missing');

      this.submitting = true;
      try {
        const data = await this.$server.create("balancesHistories", { amount, country: this.idWharhouse.country });
        if (data && data._id) {
          this.withdrawAmount = "";
          await this.fetchWallet();
          this.$toast.success(this.label('Withdrawal request created', 'Demande de retrait créée'));
        } else {
          this.$toast.warning((data && (data.content || data)) || 'Error');
        }
      } catch (e) {
        this.$toast.warning('Error');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
